import styled from "styled-components";

import { fontFamily } from "../../../../global.style";

export const Container = styled.div`
  min-height: 262px;
  display: flex;
  padding: 33px 130px;
  align-items: center;
  gap: 30px;
  background: #0e1e64;

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 24px 50px;
    align-items: flex-start;
  }
`;

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  h1 {
    font-family: ${fontFamily.brand};
    color: #fff;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 46px;

    @media (max-width: 767px) {
      font-size: 24px;
      font-weight: 500;
    }
  }

  h2 {
    font-family: ${fontFamily.brand};
    color: #fff;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;

    @media (max-width: 767px) {
      font-size: 20px;
      font-weight: 400;
    }
  }
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
`;

export const Item = styled.div`
  margin-bottom: 5px;
  display: flex;
  align-items: start;
  gap: 12px;

  img {
    position: relative;
    top: 7px;
  }

  span {
    -webkit-font-smoothing: antialiased;
    font-family: ${fontFamily.brand};
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    color: #fff;
  }
`;
